import React from 'react';
import NextButton from './NextButton';

const SephoraClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>
        I know you finally got rid of some makeup (why did you still have
        something from your ex anyways?)... head on over to Sephora and buy
        yourself some replacements 😊
      </p>
      <img src='sephora.jpg' style={{ width: '100%' }} />
      <p>
        p.s. yes I know you like to buy things online but please try to get at
        least 1 thing! it will make me happy
      </p>
      <NextButton
        prompt='Enter the brand of the makeup I got you for Christmas'
        acceptedClues={['givenchy']}
      />
    </div>
  );
};

export default SephoraClue;
